import { AiStatusCondition as AiStatusConditionType } from "@redotech/redo-model/advanced-flow/rules-v3/schemas";
import { QueryOperator } from "@redotech/redo-model/advanced-flow/rules/types";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

/**
 * AI Status condition editor.
 *
 * Only `HANDED_OFF` is supported today, so there's no merchant input —
 * the description just flips based on the condition's `queryOperator`.
 * When `AI_STATUSES` grows beyond `ACTIVE` / `HANDED_OFF`, replace this
 * with a real multi-select UI modelled on `TicketStatusV3Condition`.
 */
export const AiStatusCondition = memo(function AiStatusCondition({
  condition,
}: {
  condition: AiStatusConditionType;
  onChange: (updated: AiStatusConditionType) => void;
  /** No interactive inputs — prop accepted for interface consistency. */
  editableFields?: ReadonlySet<string>;
}) {
  const negated = condition.queryOperator === QueryOperator.IS_NOT;
  return (
    <Text fontSize="sm" textColor="secondary">
      Matches when the AI agent has {negated ? "not " : ""}handed off the
      conversation.
    </Text>
  );
});
